// ──────────────────────────────────────────────────────────────────────────────
// Data Collapse HES — API service layer.
// All calls go to backend: /dataCollapse/*  (reads ClickHouse lampiran_hid_perbelanjaan)
// ──────────────────────────────────────────────────────────────────────────────

import axios from "../../plugins/axios";

const API = process.env.VUE_APP_API_URL;

/** Column catalogue for the "Pilihan Kolum" picker. */
export async function getColumns() {
  const res = await axios.get(`${API}/dataCollapse/getColumns`);
  return res.data; // { criteria, measures, defaults }
}

/**
 * One server-paginated page of the listing. POST (not GET) so a large chosen-column
 * list travels in the body instead of the URL (a 2000+ column GET query overflows the
 * URL length limit and fails).
 */
export async function fetchTable({ page, itemsPerPage, negeri, pusingan, columns, sortBy, sortDesc }) {
  const res = await axios.post(`${API}/dataCollapse/getData`, {
    page: page || 1,
    itemsPerPage: itemsPerPage || 25,
    negeri: negeri || "",
    pusingan: pusingan || "",
    columns: columns || [],
    sortBy: (sortBy && sortBy.length) ? sortBy[0] : "",
    sortDesc: (sortDesc && sortDesc.length) ? sortDesc[0] : false,
  });
  return res.data; // { items, total, columns }
}

/**
 * Download the CSV export as a Blob (auth token attached by the axios interceptor).
 *   mode = 'selected' → criteria + chosen measure columns
 *   mode = 'all'      → criteria + every measure column
 */
export async function downloadCsv({ negeri, pusingan, columns, mode }) {
  const res = await axios.post(
    `${API}/dataCollapse/exportCsv`,
    {
      negeri: negeri || "",
      pusingan: pusingan || "",
      columns: columns || [],
      mode: mode || "selected",
    },
    { responseType: "blob" }
  );
  return res.data; // Blob
}

// ── Pre-generated CSV files ("Sedia Ada") ────────────────────────────────────────
// List-shaped: each dataset carries its own criteria, file status and progress, so
// new criteria added on the server appear here with no frontend change.

/** All prepared datasets: [{ key, criteria, criteriaText, exists, meta, state }]. */
export async function preparedCsvStatus() {
  const res = await axios.get(`${API}/dataCollapse/preparedCsvStatus`);
  return res.data; // { datasets: [...] }
}

/** Trigger a (re)generation of one dataset (runs in the background). */
export async function prepareCsv(key) {
  const res = await axios.post(`${API}/dataCollapse/prepareCsv`, { key: key || "all" });
  return res.data;
}

/** Mint a short-lived, single-use download ticket bound to one dataset. */
export async function csvTicket(key) {
  const res = await axios.post(`${API}/dataCollapse/csvTicket`, { key: key || "all" });
  return res.data; // { ticket, key }
}

/** Build the direct download URL for a ticket (streams to disk via a browser nav). */
export function preparedDownloadUrl(ticket) {
  return `${API}/dataCollapse/downloadPreparedCsv?t=${encodeURIComponent(ticket)}`;
}
